
export class TransferStateOriginMap implements Record<string, string> {
  [x: string]: string;

  static init(config: TransferStateOriginMap, apiMappings: { internalApi: string, publicApi: string }[]){

    for(const mapping of apiMappings){
      config[mapping.internalApi] = mapping.publicApi;
    }
  }

}